<script setup lang="ts">
import useMatestoreStore from '@/store/matestoreStore';
import { TabItem } from '@/api/model/globalModel';
import { debounce } from 'lodash-es';
import { computed, ref } from 'vue';
import HistoryTabName from '@/components/tabs/HistoryTabName.vue';

const matestoreStore = useMatestoreStore();
const keywordRef = ref('');
const handleTabItemClick = (tabItem: TabItem) => {
  window.location.hash = `#${tabItem?.fullPath?.split('#')[1]}`;
};

const handleCloseTab = (tabItem: TabItem, index: string) => {
  matestoreStore.removeTabItem(tabItem.microName, Number(index));
};

const debSearching = debounce((e: any) => {
  console.log('searching', e.target?.value);
  keywordRef.value = e.target?.value;
}, 300);

const filtedTabs = computed<TabItem[]>(() => {
  let keyword = keywordRef.value;
  keyword = keyword.trim();
  if (!keyword) {
    return matestoreStore.microRouteHistory;
  }
  return matestoreStore.microRouteHistory.filter((i) => {
    return i.title?.includes(keyword) || i.fullPath?.includes(keyword);
  });
});

const handleCloseAll = () => {
  matestoreStore.removeAllTabs(matestoreStore.currentApp.name);
};
</script>

<template>
  <n-popover trigger="click-remain" class="popover" placement="bottom-end">
    <template #reference>
      <slot></slot>
    </template>
    <template #popper>
      <div class="popover-content">
        <div class="popover-title">
          <h3>打开的页签</h3>
          <n-button type="text" size="small" @click="handleCloseAll"
            >全部关闭</n-button
          >
        </div>
        <div class="popover-search">
          <n-input
            clearable
            prefix-icon="search"
            placeholder="请搜索"
            @keydown="debSearching"
            @clear="keywordRef = ''"
          />
        </div>
        <div class="tab-item-list">
          <template v-if="filtedTabs.length > 0">
            <div
              v-for="(item, index) in filtedTabs"
              :key="index"
              class="tab-item"
              @click="handleTabItemClick(item)"
            >
              <p><history-tab-name :route="item" :name="item.title" /></p>
              <n-button
                icon="close"
                class="close-btn"
                type="text"
                size="small"
                kind="neutral"
                @click.stop="handleCloseTab(item, index as string)"
              ></n-button>
            </div>
          </template>
          <n-empty size="large">
            <template #description>
              <p>暂无搜索结果,换个词试试?</p>
            </template>
          </n-empty>
        </div>
      </div>
    </template>
  </n-popover>
</template>

<style scoped lang="scss">
.popover-content {
  border-radius: 8px;
  background: #fff;
  width: 368px;
  box-shadow: 0px 5px 15px 2px rgba(0, 0, 0, 0.08);
  padding-bottom: 24px;

  .popover-title {
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      color: #040b29;
    }
  }

  .popover-search {
    padding: 4px 16px;
  }

  .tab-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    > p {
      line-height: 27px;
    }
    .close-btn {
      display: none;
    }
    &:hover {
      background: #f6f7fa;
      .close-btn {
        display: block;
      }
    }
  }
}
</style>
